import { render, staticRenderFns } from "./PaymentLogos.vue?vue&type=template&id=9ec19a28&"
import script from "./PaymentLogos.vue?vue&type=script&lang=js&"
export * from "./PaymentLogos.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLogos.vue?vue&type=style&index=0&module=true&lang=postcss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports